// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__3Q-BZ","icon":"Search_icon__2He--","input":"Search_input__3iTQH","selectUf":"Search_selectUf__2t0Xt","searchContainer":"Search_searchContainer__16Jdk"};